import { render } from "./ErrorWallpaper.vue?vue&type=template&id=48f3651f&scoped=true"
import script from "./ErrorWallpaper.vue?vue&type=script&lang=js"
export * from "./ErrorWallpaper.vue?vue&type=script&lang=js"

import "./ErrorWallpaper.vue?vue&type=style&index=0&id=48f3651f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48f3651f"

export default script